import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { AccountActions } from '@app/core/actions';
import { CookiesService } from '@app/core/services/cookies.service';
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { concatMap, filter, withLatestFrom, take } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class SelectTeamGuard implements CanActivate {

  constructor(
    private store$: Store<fromRoot.State>,
    private cookiesService: CookiesService,
    @Inject(PLATFORM_ID) private platformId: object
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      return of(true)
    }
    return this.store$.pipe(
      withLatestFrom(
        this.store$.select(fromRoot.getUserTeams),
        // this.store$.select(fromRoot.selectRouteParams),
      ),
      filter(([store, teams]) => teams.length > 0),
      take(1),
      concatMap(([store, teams]) => {
        if (teams.find(team => team.id === route.paramMap.get('id'))) {
          this.store$.dispatch(AccountActions.updateActiveTeam({ team: teams.find(team => team.id === route.paramMap.get('id')) }));
          return of(true);
        } else if (this.cookiesService.getCookie('lastActiveTeam')) {
          const lastActiveTeam = this.cookiesService.getCookie('lastActiveTeam');
          const resolvedTeam = teams.find(team => lastActiveTeam?.team === team?.id);
          this.store$.dispatch(AccountActions.updateActiveTeam({ team: resolvedTeam }));
          return of(true);
        } else {
          window.location.href = '/404';
          return of(false);
        }
      })
    )
  }
}
